module.exports = __webpack_public_path__ + "static/media/2 playingcards gamble tattoo sleeve skull female blackwork dotwork.1280x1707.c698dd5f.webp";